module.exports = __webpack_public_path__ + "860f4cea96829b941b9aeab46844362f.pdf";